<template>
  <template v-if="currentContentLength >= 0">
    <span class="anz-mr-xs">{{ $translate('post.other.singsNumber') }}: </span>
    {{ input.length }} / {{ CONTENT_MAX_LENGTH }}
  </template>
  <template v-else>
    <div class="anz-color-error anz-flex-inline anz-align-items-center">
      <a-icon
        width="1.1em"
        height="1.1em"
        name="exclamation-circle"
        class-name="anz-mr-xs anz-mtn-xxs"
      />
      {{ $translate('post.other.singsNumberOverrun') }}
      {{ input.length }} / {{ CONTENT_MAX_LENGTH }}
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { PostContentConstraints } from '@/validation/postValidator'
import AIcon from '@/components/AIcon.vue'

export default defineComponent({
  name: 'PostTextCounter',
  components: { AIcon },
  props: {
    input: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      CONTENT_MAX_LENGTH: PostContentConstraints.MAX_LENGTH,
    }
  },
  computed: {
    currentContentLength(): number {
      let currentLength = 0

      if (typeof this.input !== 'undefined') {
        currentLength = this.CONTENT_MAX_LENGTH - this.input.length
      }

      return currentLength
    },
  },
})
</script>
